import i18n from 'i18next';
import {ShadowType} from '../../../../incase-domain/common/elementShadow';
import {ELEMENT} from '../../../../incase-domain/elements/base/ElementTypes';
import {IElementQuestion} from '../../../../incase-domain/elements/question/question';
import {IPresentationTheme} from '../../../../incase-domain/presentationTheme';
import {defaultFonts} from '../../../../utils/defaultFonts';

export const THEME_QUESTION_PREVIEW_ID = 'presentation-theme-question-preview';

export function buildThemeQuestionPreviewElement(presentationTheme: IPresentationTheme): IElementQuestion {
    const questionTheme = presentationTheme.elementStyles?.questionElement;
    const selectedFont =
        questionTheme?.fontFamily ||
        [...(presentationTheme.fonts || []), ...(presentationTheme.defaultFonts || defaultFonts)].find((font) => font.selected) ||
        defaultFonts[0];

    const answerLabel = i18n.t('presEditPage.editSidebar.elements.initialStates.answer');
    const answers = [
        {
            text: `${answerLabel} 1`,
            type: 'correct' as const,
            comment: i18n.t('presEditPage.editSidebar.elements.initialStates.yesNoQuestionComment'),
        },
        {
            text: `${answerLabel} 2`,
            type: 'incorrect' as const,
            comment: '',
        },
        {
            text: `${answerLabel} 3`,
            type: 'debatable' as const,
            comment: '',
        },
    ];

    return {
        id: THEME_QUESTION_PREVIEW_ID,
        name: 'theme-question-preview',
        type: ELEMENT.QUESTION,
        xPosition: 0,
        yPosition: 0,
        angle: 0,
        height: 'auto',
        width: '100%',
        slideId: 'theme-preview',
        keyIndex: THEME_QUESTION_PREVIEW_ID,
        elementIndex: 0,
        title: '',
        label: '',
        color: '',
        question: i18n.t('presEditPage.editSidebar.elements.initialStates.question'),
        answers,
        correctAnswers: [0],
        singleCorrect: false,
        isDebatable: true,
        haveTryButton: true,
        tryLabel: 'Confirm',
        showAllComments: false,
        writeAnswerIndices: true,
        showInReport: true,
        fitContent: true,
        fontSize: questionTheme?.answerFontSize?.value || 1.2,
        questionFontSize: questionTheme?.questionFontSize?.value || 1.2,
        commentFontSize: questionTheme?.commentFontSize?.value || 1.2,
        questionBackgroundColor: questionTheme?.questionBackgroundColor,
        questionBackgroundBorderRadius: questionTheme?.questionBackgroundBorderRadius,
        questionTextAlign: questionTheme?.questionTextAlign,
        fontFamily: selectedFont,
        correctColor: questionTheme?.correctColor,
        incorrectColor: questionTheme?.incorrectColor,
        debatableColor: questionTheme?.debatableColor,
        correctCommentColor: questionTheme?.correctCommentColor,
        incorrectCommentColor: questionTheme?.incorrectCommentColor,
        debatableCommentColor: questionTheme?.debatableCommentColor,
        borderRadius: questionTheme?.borderRadius,
        boxShadow: questionTheme?.boxShadow ?? ShadowType.MEDIUM,
    };
}
